module.exports = {
  language: 'Bahasa Indonesia',
  //首页
  homePage: {
    tab_buy: 'Beli Kripto',
    tab_sell: 'Jual Kripto',
    //买币
    youPay: 'Anda membayar',
    youBuyGet: 'Anda mendapatkan',
    buyFee_title1: 'Anda mendapatkan',
    //卖币
    youSell: 'Anda menjual',
    youSellGet: 'Anda Mendapatkan',
    sellFee_title1: 'Anda menjual',
    sellFee_title2: 'ke',
    sellFee_rampFee: 'Biaya pemrosesan',
    sellminAmount: 'Jumlah penjualan minimum',
    sellmaxAmount: 'Jumlah penjualan maksimum',
    minAmountTips: 'Jumlah transaksi minimum adalah',
    maxAmountTips: 'Jumlah transaksi maksimum adalah',

    bottomTips1: 'Diproses · Jual',
    bottomTips2: 'Diproses . Beli',
    //钱包地址验证页的提示
    receivingMode: 'Harap pastikan alamat yang dimasukkan sudah tepat sebelum mengonfirmasi proses transfer. Jangan kirimkan token ke alamat orang lain. Alamat yang tidak kompatibel akan mengakibatkan pesanan gagal atau kehilangan dana.'
    // bottomTips2: 'Didukung Oleh',
  },
  //世界杯多语言文案
  worldCuo: {
    World: 'Piala Dunia Qatar 2022',
    discount: 'Diskon 50%',
    Rampfee: 'pada Biaya pemrosesan pesanan pertama Anda',
    Details: 'Detail',
    WorldCup: 'Piala Dunia',
    WorldDiscount: 'Diskon Piala Dunia',
    Participated: 'Berpartisipasi',
    order: 'satu pesanan ini',
    countdown: 'Hitung mundur acara',
    countdownstart: 'Acara akan segera dimulai'
  },

  //墨西哥支付页面改版本案
  mexPayment: {
    tiemOut: 'Pesanan akan dibatalkan dalam ',
    PleasePay: 'Harap Bayar',
    title1: 'Buka aplikasi bank Anda. Masukkan nomor referensi ini  ',
    title2: 'Masukkan informasi pendaftaran akun',
    CLABEinterbancaria: 'CLABE interbancaria:',
    Destinationbank: 'Bank tujuan:',
    Beneficiary: 'Penerima:',
    Payamount: 'Jumlah pembayaran:',
    title3: 'Jika pembayaran Anda sudah lama tidak diselesaikan, sebaiknya Anda mengunggah dokumen pembayaran ke layanan pelanggan kami. Cara ini akan mempercepat konfirmasi pembayaran Anda.'
  },

  // 尼日利亚支付页面文案
  ngnPayment: {
    title2: 'Tinggalkan ACH Ramp. Masuk ke APL bank Anda dan transfer jumlah yang akurat ke akun di bawah ini.',
    accountNumber: 'Nomor Akun:',
    accountName: 'Nama Akun:',
    bankName: 'Nama Bank:',
    title3: 'Setelah transfer, harap kembali ke RAMP dan klik tombol di bawah ini - Saya telah menyelesaikan pembayaran.',
    iDType: 'Jenis ID',
    dobTitle: 'Harap Masukkan Tanggal Lahir',
    dateTip: 'Tanggal tidak valid',
    idNumberPlaceholder: 'Masukkan nomor ID 12 digit',
    idNumberTitle: 'Harap Masukkan nomor tanggal lahir',
    addressTitle: 'Harap Masukkan Alamat ID',
    addressTip: 'Alamat tidak valid'
  },

  //等待结果组件
  buypayWait: {
    Processing: 'Sedang Diproses',
    Waiting: 'Menunggu pembelian Anda…',
    purchase: 'Harap dilanjutkan ke halaman pembayaran untuk menyelesaikan pembelian Anda.',
    Afterpayment: 'Setelah pembayaran Anda',
    Wepurchase: 'Kami akan mengirimkan email saat menerima pembelian Anda agar Anda dapat menemukannya dengan mudah nanti.',
    historyorder: 'Lihat riwayat pesanan'
  },
  //菲律宾页面
  phpPayment: {
    PaymentGuide: 'Panduan Pembayaran',
    BillNumber: 'Nomor Kiriman Digital',
    PAYSO1: 'Masukkan dompet Gcash, klik "Tagihan" dan pilih pembayaran tagihan',
    PAYSO2: 'Cari dan pilih "PAYSO"',
    PAYSO3: 'lengkapi berbagai informasi ini, dan klik [BERIKUTNYA]',
    Incorrect: 'Harap pastikan jumlah yang Anda transfer kepada kami sudah akurat. Informasi atau jumlah yang salah akan mengakibatkan pesanan gagal atau kehilangan dana.'
  },
  //vnd新增文案 越南支付文案
  vndChildren: {
    amount: 'Jumlah',
    oneTitle: `Buka apl perbankan, pindai kode QR atau masukkan ID penerima secara manual`,
    twoTitle: ' Isi jumlah transfer di kotak pesan',
    threeTitle: ' Lakukan transfer uang',
    Accountname: 'Nama akun',
    AccountID: 'ID Akun',
    Transfercontent: 'Jumlah transfer'
  },
  //买币表单新增文案
  sellFormPageTitle: {
    Information: 'Gunakan Informasi ini',
    AccountNumber: 'Nomor akun',
    More: 'Selengkapnya',
    Attention: 'Perhatian',
    ReturnediInformation: 'Harap pastikan akun bank ini milik Anda dan informasinya sudah akurat. Transaksi yang dikembalikan akan dikenakan biaya $25 yang dibebankan oleh mitra perbankan kami.',
    buy_configphp_codeTips: 'Pindai kode QR melalui QRPH Anda untuk menyelesaikan pembayaran'
  },
  //导航文案
  navTabTitle: {
    Completepayment: 'Selesaikan pembayaran'
  },
  //买币费用组件
  buyFee_components: {
    codeSecond: 's',
    youGet: 'Anda mendapatkan',
    youOrder: 'Pesanan Anda',
    title2: 'untuk',
    rampFee: 'Biaya pemrosesan',
    rampFeeTips: 'serendah',
    networkFee: 'Biaya jaringan',
    tips: 'Biaya ini dibebankan oleh Alchemy Pay untuk menutup biaya yang terkait dengan pemrosesan pembayaran. Biaya ini dapat berbeda-beda berdasarkan metode pembayaran yang dipilih Anda kemudian.',
    networkFeeTips: "Ini adalah sistem yang memproses keamanan transaksi di blockchain. Juga dikenal sebagai 'Biaya gas' atau 'Biaya Blockchain'",
    updatingRates: 'Memperbarui tarif',
    updateIn: 'Perbarui dalam&nbsp;<span>{0}</span>&nbsp;detik'
  },
  //卖币费用组件
  sellFee_components: {
    codeSecond: 's',
    title1: 'Anda Menjual',
    title2: 'ke',
    rampFee: 'Biaya pemrosesan',
    tips: 'Berdasarkan metode pembayaran',
    RampFeeTips: 'serendah'
  },
  //菜单
  menu: {
    home: 'Beranda',
    menu: 'Menu',
    transactions: 'Transaksi',
    language: 'Bahasa',
    privacy: 'Kebijakan Privasi',
    logOut: 'Keluar',
    service: 'Ketentuan Layanan',
    RouterMenu_experience: 'Login untuk membuka agar mendapatkan pengalaman penuh',
    login_Youlogged: 'Anda sudah login',
    RouterMenu_Welcome: 'Selamat datang di Alchemy Pay!',
    RouterMenu_history: 'Belum ada riwayat',
    loginOut_Dismiss: 'Tolak',
    loginOut_title: 'Anda yakin ingin keluar?'
  },

  //买币接收方式页 //买币填写地址页面
  buyReceivingMethod: {
    networkTitle1: 'Masukkan',
    networkTitle2: 'alamat Anda',
    addressTips1: 'Bukan alamat',
    addressTips2: 'yang valid.',
    memo: 'Memo',
    memoTips: 'Bukan memo ACH yang valid.',
    ENSTips: 'Masukkan alamat dompet yang valid, ENS atau Unstoppable domain.',
    supported: 'domain yang didukung',
    Unstoppable: 'Kami mendukung unstoppable domain untuk aset ini',
    tips: 'Harap pastikan alamat ini sungguh milik Anda. Saat aset menjadi aktif di blockchain, kami tidak dapat membantu Anda membatalkan pesanan ini.'
  },
  //---------------------------- 阿根廷支付页面 ----------------------------
  ArgentinaPay: {
    BankCode: 'Kode bank',
    ChooseBank: 'Pilih Bank Anda',
    selectcard: 'Harap pilih bank',
    BankAccount: 'Akun Bank',
    cardnumber: 'Harap masukkan nomor kartu yang tepat',
    Bankcode: 'Kode Bank',
    correctcode: 'Harap masukkan kode yang tepat',
    ID: 'ID',
    SelectBank: 'Pilih Bank',
    phone: 'Nomor telepon',
    phoneTips: 'Nomor telepon tidak valid!',
    paymentResultError: 'Informasi akun bank tidak tepat. Silakan periksa dan beli lagi.',
    Choose: 'Pilih jenis akun Anda',
    chequing: 'Cek',
    Saving: 'Tabungan',
    AccountNumber: 'Nomor akun',
    fullNameTips: 'Nama lengkap tidak valid'
  },
  //买币选择支付方式页
  buyPayWay: {
    BINANCEPAY: 'Binance Pay',
    qrCode: 'Kode QR',
    Khipu: 'Transfer Bank',
    ThaiQR: 'ThaiQR',
    Philippines: 'Transfer Bank',
    saas: 'PayNow',
    pix: 'PIX',
    ChangeCard: 'Ubah kartu bank',
    recentlyUsed: 'Metode pembayaran tersimpan',
    paymentMethod: 'Tambahkan metode pembayaran baru',
    towMethod: 'Ubah metode pembayaran',
    rampFee: 'Biaya pemrosesan',
    card: 'Kartu',
    card1: 'Kartu',
    creditCard: 'Kartu kredit',
    bankTransfer: 'Prompt Pay',
    bancoTransfer: 'Transfer Bank',
    opm: 'SPEI(OPM)',
    virtualAccount: 'Transfer Bank',
    eWallet: 'Dompet Elektronik',
    binancePay: 'Binance Pay',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    promptPay: 'Prompt Pay',
    addCardTitle: 'Tambahkan Kartu Baru',
    useCardTitle: 'Gunakan kartu baru',
    edit: 'Edit',
    cancel: 'Batal',
    support: 'Dukungan',
    cardLimitTips: 'Batas 6 Kartu Tercapai',
    Unavaible: 'Tidak tersedia',
    limit: 'Batas'
  },

  //买币国际卡表单组件
  buyForm_components: {
    formTitle: 'Masukkan detail kartu Anda.',
    firstName: 'Nama depan',
    lastName: 'Nama belakang',
    nameTips: 'Nama tidak valid!',
    cardNumber: 'Nomor kartu',
    cardNumTips: 'Anda telah memasukkan nomor kartu yang tidak valid',
    expirationDate: 'Tanggal kedaluwarsa',
    dataTips: 'Tanggal kedaluwarsa tidak valid',
    cvv: 'CVV',
    cvvTips: 'Masukkan CVV yang valid',
    NameError: 'Nama tidak cocok dengan kartu, harap diperbaiki',
    phone: 'Telepon',
    phoneTips: 'Telepon tidak valid!',
    birthDate: 'Tanggal lahir',
    birthDateTips: 'Tanggal lahir tidak valid!',
    birthDate_select_title: 'Pilih tanggal',
    birthDate_select_cancel: 'Batal',
    birthDate_select_confirm: 'Konfirmasi'
  },

  //国际卡确定订单页 - 老变量没有处理
  creditCard: {
    payingWith: 'Membayar dengan',
    card: 'kartu',
    cvv: 'CVV'
  },

  //买币确定订单页 - 巴西支付
  configPay_brl: {
    phoneNumber: 'Nomor ponsel',
    fullName: 'Nama lengkap',
    formTitle: 'Masukkan detail Anda.',
    code_tips: 'Pindai kode QR melalui PIX Anda untuk menyelesaikan pembayaran.',
    name_tips: 'Nama tidak valid!',
    id_tips: 'Id tidak valid!',
    number_tips: 'Nomor ponsel tidak valid!',
    Country: 'Pilih negara'
  },

  opmPayment: {
    banco: 'Bank'
  },

  //买币结果页
  payResult: {
    //支付结果提示
    tipsText_40010: 'Data kartu tidak akurat. Harap periksa informasi kartu.',
    tipsText_40011: 'Data kartu tidak akurat. Harap periksa informasi kartu.',
    tipsText_40019: 'Data kartu tidak akurat. Harap periksa informasi kartu.',
    tipsText_40020: 'Dana tidak mencukupi',
    tipsText_40030: 'Yurisdiksi kartu dibatasi. Harap coba kartu yang lain.',
    tipsText_40031: 'Kartu dibatasi',
    tipsText_40032: 'Kartu bermasalah',
    tipsText_40033: 'Kartu dibatasi',
    tipsText_40034: 'Kartu dibatasi, kontrol risiko.',
    tipsText_40090: 'Penolakan tidak wajar'
  },

  //搜索组件
  search_components: {
    recent: 'Terbaru',
    availableNow: 'Tersedia sekarang',
    listLoading: 'memuat',
    listErrorText: 'Permintaan gagal, klik muat ulang',
    listFinishedText: 'Tidak ada lainnya'
  },
  //弹出框文案
  payConfig_components: {
    title_THB: 'Pembayaran sedang berlangsung',
    button_THB: 'Periksa pesanan',
    button_timeOut: 'Kembali ke halaman beranda',
    button_timeOut1: 'Kembali ke Beranda',
    double: 'Harap tidak melakukan pembayaran ganda',
    completed: 'Harap konfirmasikan penyelesaian transfer Anda.',
    timeorder: 'Waktu pesanan ini sudah lewat.',
    checkout: 'Apakah Anda yakin ingin meninggalkan konter pembayaran?',
    buttonLeave: 'Tinggalkan sekarang',
    // 卖币
    // 退款失败提示
    refundError: 'Permintaan pengembalian dana Anda telah dikirim'
  },

  //按钮组件
  button_components: {
    proceed: 'Diproses'
  },

  //选择网络组件
  network_components: {
    network: 'Pilih jaringan'
  },

  //---------------------------- 支付方式信息组件 ----------------------------
  PayMethodInfo_components: {
    title: 'Ringkasan pesanan',
    title2: 'Metode pembayaran yang Anda pilih adalah'
  },
  //---------------------------- 扫码QR Code组件 ----------------------------
  QrCode_components: {
    title1: 'Bayar',
    title2: 'untuk menyelesaikan pembelian Anda.',
    title3: 'Harap buka aplikasi pembayaran Anda dan pindai kode QR di bawah ini untuk menyelesaikan pembayaran.',
    copy: 'SALIN',
    amount_pay: 'Jumlah pembayaran:'
  },
  //---------------------------- 钱包地址和网络信息组件 ----------------------------
  WalletAddress_components: {
    title1: 'Anda',
    title2: 'dompet'
  },
  //---------------------------- 表单信息 ----------------------------
  formInfo: {
    //新增
    fullName_placeholder: 'Masukkan nama lengkap',
    phone_title: 'Masukkan nomor telepon Anda',
    id_title: 'Masukkan nomor ID',
    id_placeholder1: 'Masukkan',
    id_placeholder2: 'digit nomor ID',
    select_id_placeholder: 'Pilih jenis ID Anda',
    bankAccount_placeholder: 'Pilih jenis akun Anda',
    accountNumber_placeholder: 'Masukkan nomor ID 22 digit',
    bankCode_placeholder: 'Masukkan nomor ID 3 digit',
    //vnd 选择bank code
    vnd_bankCode_placeholder: 'Pilih kode bank'
  },

  // 卖币

  /**
   * 卖币
   */
  //卖币支付页+订单状态页
  sellOrderFonts: {
    minimumAmount: 'Pesanan Anda di bawah jumlah minimum',
    maximumAmount: 'Pesanan Anda lebih dari jumlah maksimum',
    sellTitle: 'Jual',
    Sellorder_Network: 'Pilih Jaringan',
    Sellorder_Ramp: 'Biaya pemrosesan ',
    Sellorder_PleaseCorrect: 'Harap pastikan jaringan yang dipilih sudah tepat untuk menghindari kehilangan aset.',
    Sellorder_transferred: 'Saya telah mentransfer kripto ke alamat dan jaringan yang ditunjukkan.',
    Sellorder_ButtonNot: 'Belum',
    Sellorder_ButtonConfirm: 'Konfirmasi',
    Sellorder_ButtonHaveSent: ' Saya telah mengirimkan ',
    Sellorder_ButtonGoMerchant: 'Tarik Dari ',
    Sellorder_ButtonGoMerchant1: 'Tarik Dari ',
    Sellorder_ButtonGoMerchant2: '',
    Sellorder_ButtongoHome: '  Kembali ke halaman beranda',
    Sellorder_ButtongoHistory: 'Riwayat pesanan',
    Sellorder_timeOutTitle: ' Pesanan Anda telah kedaluwarsa, harap tidak mengirimkan uang ke alamat ini. Jika tidak, dapat terjadi kehilangan aset.',
    Sellorder_StatusTitle: 'Anda dapat meninggalkan halaman ini. Setiap pembaruan pesanan ini akan dikirimkan ke email Anda, dan juga dapat diperiksa di riwayat pesanan.',
    Sellorder_StatusNav: 'Status pesanan',
    Sellorder_StatusCryptoSent: 'Kripto Terkirim',
    Sellorder_StatusBlockConfirmed: 'Blok terkonfirmasi',
    Sellorder_StatusConfirmOrder: 'Konfirmasi pesanan',
    Sellorder_StatusOrderconfirmed: 'Pesanan Anda telah dikonfirmasi',
    Sellorder_StatusInTransfer: 'Dalam transfer',
    Sellorder_StatusInTransferfiat: 'Fiat Anda dalam transfer',
    Sellorder_StatusResult: 'Hasil',
    Sellorder_StatusResultCompleted: 'Pesanan selesai',
    Sellorder_StatusResultfail: 'Pesanan gagal',
    //卖币状态
    Sellorder_transfer: 'Harap transfer ',
    Sellorder_within: 'ke alamat dalam ',
    Sellorder_will: 'akan ',
    Sellorder_get: 'mendapatkan ',
    Sellorder_for: '  untuk ',
    Sellorder_Id: 'ID Pesanan',
    Sellorder_Address: 'Alamat',
    Sellorder_Fail: 'Alasan Gagal',
    Sellorder_You: 'Anda Menjual',
    Sellorder_to: 'ke',
    SellOrder_modified: 'Saat ini informasi kartu tidak dapat diubah'
  },

  // 卖币选择支付方式
  sellPayType: {
    title: 'Metode pembayaran',
    type_card: 'Kartu',
    type_card_tips: 'Waktu pemrosesan dapat berlangsung hingga 15 menit',
    type_bankAccount: 'Akun Bank',
    type_type_bankAccount_tips: 'Waktu pemrosesan dapat berlangsung hingga 2-3 hari',
    form_tips: 'Ke kartu mana kami harus mengirim dana?',
    form_bankAccount_tips: 'Ke akun bank mana kami harus mengirim dana?',
    payoutList_ActionSheet_title: 'Metode pembayaran',
    creditcard_form_tips: 'Harap pastikan rekening ini milik Anda dan informasinya sudah tepat.',
    creditcard_tab_name: 'Edit informasi kartu Anda',
    bankAccount_tab_name: 'Edit informasi akun bank Anda',
    master_card: 'Mastercard',
    visa_card: 'Visacard',
    bank_account: 'Akun Bank'
  },

  //卖币表单页
  sellForm: {
    phone: 'Telepon',
    phoneTips: 'Nomor telepon tidak valid!',
    tips: 'kiat',
    fullName: 'Nama lengkap',
    lastName: 'Nama belakang',
    NameTips: 'Nama tidak valid!',
    Address: 'Alamat',
    AddressTips: 'Alamat tidak valid!',
    AddressMultinomialTips: 'Alamat tidak boleh kosong',
    City: 'Kota',
    CityTips: 'Kota tidak valid!',
    State: 'Negara Bagian',
    StateTips: 'Negara bagian tidak valid!',
    Postcode: 'Kode Pos',
    PostcodeTips: 'Kode pos tidak valid!',
    accountNumber: 'Nomor akun',
    accountNumberTips: 'Nomor akun tidak valid!',
    achCode: 'Kode ACH',
    achCodeTips: 'Kode ACH tidak valid!',
    contactNumber: 'Nomor kontak',
    contactNumberTips: 'Nomor kontak tidak valid!',
    swiftCode: 'Kode swift',
    swiftCodeTips: 'Kode swift tidak valid!',
    branchName: 'Nama cabang',
    branchNameTips: 'Nama cabang tidak valid!',
    branchNameMultinomialTips: 'Nama cabang tidak boleh kosong',
    accountType: 'Jenis akun',
    accountTypeTips: 'Jenis akun tidak valid!',
    bankAccountType: 'Jenis akun bank',
    bankAccountTypeTips: 'Jenis akun bank tidak valid!',
    bankAccountTypeLi_Saving: 'Tabungan',
    bankAccountTypeLi_Checking: 'Cek',
    bankAccountTypeLi_TimeDeposit: 'Deposito berjangka',
    bankAccountTypeLi_Others: 'Lainnya',
    bankCode: 'Kode Bank',
    bankCodeTips: 'Kode bank tidak valid!',
    branchCode: 'Kode cabang',
    branchCodeTips: 'Kode cabang tidak valid!',
    locationId: 'Id lokasi',
    locationIdTips: 'Id lokasi tidak valid!',
    CPFNumber: 'Nomor CPF',
    CPFNumberTips: 'Nomor CPF tidak valid!',
    IDType: 'Jenis ID',
    IDTypeTips: 'Jenis ID tidak valid!',
    bankAccountTypeLi_CUIT: 'CUIT',
    bankAccountTypeLi_CUIL: 'CUIL',
    IDNumber: 'Nomor ID',
    IDNumberTips: 'Nomor ID tidak valid!',
    accountTypeLi_Maestra: 'Maestra',
    IDTypeLi_DNI: 'DNI',
    IDTypeLi_RUC: 'RUC',
    IDTypeLi_CE: 'CE',
    IDTypeLi_PASS: 'PASS',
    RUTNumber: 'Nomor RUT',
    RUTNumberTips: 'Nomor RUT tidak valid!',
    BSBCode: 'Kode BSB',
    BSBCodeTips: 'Kode BSB tidak valid!',
    Email: 'Email',
    EmailTips: 'Email tidak valid!',
    SortCode: 'Kode urut',
    SortCodeTips: 'Kode urut tidak valid!',
    IFSC: 'IFSC',
    IFSCTips: 'IFSC tidak valid!',
    IDTypeLi_NIT: 'NIT',
    IDTypeLi_CC: 'CC',
    IDTypeLi_TI: 'TI',
    IDTypeLi_RUT: 'RUT',
    IDTypeLi_CI: 'CI',
    TransitNumber: 'Nomor transit',
    TransitNumberTips: 'Nomor transit tidak valid!',
    bankSwiftTips: 'Kode swift dan id lokasi tidak boleh kosong secara bersamaan',
    bankSwiftCodeTips: 'Kode bank dan kode swift tidak boleh kosong secara bersamaan',
    // bankCodeLocationIdTips: 'Kode bank dan id lokasi tidak boleh kosong secara bersamaan',
    sell_Order_network_selected: 'Untuk menghindari kehilangan aset, harap pastikan jaringan yang Anda pilih sudah tepat.',
    Sell_Order_haveSent: 'Saya telah mengirimkan ',
    Sell_Order_transferred: 'Saya telah mentransfer kripto ke alamat dan jaringan yang ditunjukkan.'
  },

  //买币历史订单页+买币订单详情页
  buyHistory: {
    buttonCard: 'Ubah kartu bank',
    buttonAgain: 'Coba lagi',
    buttonMethod: 'Ubah metode pembayaran',
    buttonInformation: 'Ubah informasi kartu',
    buttonBinance: 'Binance Pay',
    buttonApplePay: 'Apple Pay',
    buttonGooglePay: 'Google Pay',
    tryToBinance: 'Coba bayar dengan Binance Pay',
    tryToApplePay: 'Coba bayar dengan Apple Pay',
    tryToGooglePay: 'Coba bayar dengan Google Pay',
    qrCode: 'Coba bayar dengan Kode QR',
    Philippines: 'Coba bayar dengan Transfer Bank',
    eWallet: 'Coba bayar dengan Dompet Elektronik',
    buy: 'Beli',
    buyCrypto: 'Beli Kripto',
    buyCryptoHideClosed: 'Sembunyikan Pesanan Tertutup',
    buyPrice: ' Harga ',
    buyOrderAmount: 'Jumlah pesanan ',
    buyTotal: 'Total ',
    buyRampFee: 'Biaya pemrosesan ',
    buyNetworkFee: 'Biaya Jaringan ',
    buyNetwork: 'Jaringan ',
    buyAddress: 'Alamat ',
    buyOrderID: 'ID Pesanan',
    buyOrdeTime: 'Waktu pesanan',
    buyPaymentTime: 'Waktu Pembayaran',
    buyTxID: 'TxID',
    buyPaymentMethod: 'Metode Pembayaran',
    buyPayerAccount: 'Akun pembayaran',
    buyUnpaid: 'Mengonfirmasi',
    buyProcessing: 'Memproses',
    buyCompleted: 'Selesai',
    buyFailed: 'Gagal',
    buyClosed: 'Tertutup',
    history_noListText: 'Tidak ada transaksi',
    history_noListText2: 'Beli sejumlah kripto untuk memulai',
    history_noListButton: 'Beli kripto sekarang',
    history_noMore: 'Tidak ada lainnya',
    place_new_order: 'Anda dapat membuat pesanan baru dengan cara berikut.'
  },

  //卖币历史页加订单详情
  sellHistory: {
    sell: 'Jual',
    sellOrderAmount: 'Jumlah pesanan',
    sellOrderSellCrypto: 'Jual Kripto',
    sellOrderActualAmount: 'Jumlah sebenarnya',
    sellOrderFinalTotal: 'Total akhir',
    sellOrderBlockConfirmed: 'Blok Terkonfirmasi',
    sellOrderPayNow: 'Bayar sekarang',
    sellConfirmOrder: 'Konfirmasi pesanan',
    sellInTransfer: 'Dalam transfer',
    sellCompleted: 'Selesai',
    sellFailed: 'Gagal',
    sellFailedState: 'Pesanan Gagal',
    selltransferrejected: 'Transfer fiat ditolak oleh bank. Harap perbarui info bank.',
    selltransRequest: 'Minta pengembalian dana dalam USDT',
    selltransUpdate: 'Perbarui Info Bank',
    sellClosed: 'Tertutup',
    sellRefunding: 'Pengembalian dana',
    sellRefund: 'Dana Dikembalikan',
    sellSellcryptonow: 'Jual kripto sekarang',
    sellstarted: 'Jual sejumlah kripto untuk memulai',
    //卖币订单详情
    selltransRequestof: 'Minta pengembalian dana dalam USDT',
    sellUpdateInformation: 'Perbarui Informasi',
    sellPrice: 'Harga',
    sellTotal: 'Total',
    sellRampFee: 'Biaya pemrosesan',
    sellReturnfee: 'Biaya pengembalian',
    sellFinalTotal: 'Total akhir',
    sellStatus: 'Status',
    sellOrderID: 'ID Pesanan',
    sellOrderTime: 'Waktu pesanan',
    sellConfirmedTime: 'Waktu terkonfirmasi',
    sellTransferTime: 'Waktu transfer',
    sellRefundTime: 'Waktu pengembalian dana',
    sellNetwork: 'Jaringan',
    sellAddress: 'Alamat',
    sellTxID: 'TxID',
    sellRecipientAccount: 'Akun penerima'
  },
  //卖币退款页面
  RefundFonts: {
    RefundNavTitle: ' Minta pengembalian dana sebesar  ',
    RefundTitle: 'Masukkan alamat Tron (USDT) Anda',
    Refundplaceholder: 'Masukkan alamat dompet Anda',
    RefundInvalidAddress: 'Alamat tidak valid',
    Refundattention: 'Perhatikan',
    RefundPlease: ' Harap pastikan alamat yang Anda masukkan sudah tepat dan termasuk dalam jaringan yang Anda pilih. Jika memasukkan alamat yang tidak kompatibel, Anda akan kehilangan dana Anda.',
    RefundButtonConfirm: 'Konfirmasi',
    RefundSuccess: 'Pengembalian dana berhasil',
    tips: 'Harap pastikan alamat yang Anda masukkan sudah tepat dan termasuk dalam jaringan yang Anda pilih.'
  },
  //kyc验证页面
  kycVerificationFonts: {
    kycminutestitle: 'Harap verifikasi identitas Anda. Proses ini biasanya memerlukan waktu sekitar 2 menit.',
    kycPrepareyour: 'Siapkan ID Anda',
    kycminutesdocument: 'Bersiap mengambil swafoto Anda bersama dokumen.',
    kycButtonminutes: 'Mulai Verifikasi',
    kyccompleted1: 'Selamat! ',
    kyccompleted2: 'Verifikasi Anda selesai.',
    kycButtoncompleted: 'Lanjutkan Pembayaran',
    kycPayLimitUpTips: 'Batas pembayaran hingga',
    kycError: 'Verifikasi Anda gagal.',
    kycRiskAccount: 'Akun ini berisiko dan tidak dapat melakukan perdagangan sekarang.',
    kycButtonError: 'Kembali ke halaman beranda ',
    kycButtonTryAgain: 'Coba Lagi',

    kyc2_startTitle: 'Harap berikan alamat Anda.',
    kycErrorTips: 'Harap pastikan alamat Anda benar dan dapat diverifikasi',
    kycErrorTryAgain_title: 'Verifikasi Anda gagal.',
    kycErrorTryAgain_tipsTitle: 'Harap pastikan',
    kycErrorTryAgain_tips1: 'Anda telah mengirimkan dokumen ID Anda sendiri.',
    kycErrorTryAgain_tips2: 'Nama yang ada pada dokumen ID Anda sama dengan nama pemegang kartu pembayaran Anda.',
    kycErrorTryAgain_tips3: 'Anda tidak menggunakan banyak dokumen ID untuk verifikasi KYC.'
  },
  //买币结果成功文案
  paymentResult: {
    Paymentsuccess: 'Pembayaran berhasil!',
    Paymenttransfer: 'akan ditransfer ke alamat dompet Anda. ',
    Paymentemail: 'Kami akan memberitahu Anda hasilnya melalui email ',

    paymentSucceeded: {
      crypto_sending: 'Pengiriman Kripto...',
      crypto_wait: 'menunggu pembayaran',
      deposit_successed: 'Deposit berhasil!',
      payment_successed: 'Pembayaran berhasil',
      has_been_sent: '{0} {1} telah dikirim ke dompet Anda',
      quantity: 'Kuantitas:',
      network: 'Jaringan:',
      order_id: 'ID Pesanan:',
      hx_id: 'HxID:',
      notify_you_email: 'Kami juga akan memberi tahu Anda hasilnya melalui email:'
    },
    paymentFailed: {
      status: 'Status:',
      payment_failed: 'Pembayaran gagal',
      order_id: 'ID Pesanan:',
      failure_reason: 'Alasan kegagalan:',
      check_card: 'Harap periksa informasi kartu Anda'
    },
    paymentTimeout: {
      order_timeout: 'Waktu pesanan habis',
      order_expired: 'Pesanan Anda telah kedaluwarsa.',
      order_id: 'ID Pesanan:'
    }
  },
  //登陆页
  loginPage: {
    enterEmail: 'Apa alamat email Anda?',
    enterEmail1: 'Apakah ini alamat email Anda?',
    emailanother: 'Masuk dengan alamat email lain',
    emailNotyou: 'Bukan Anda?',
    codeTitle1: 'Masukkan kode login yang baru saja Anda terima',
    necessary: 'diperlukan',
    tips: 'Harap masukkan kode verifikasi yang dikirimkan ke'
  },
  nav: {
    //买币确认订单文案提示

    buyConfigPaytitle: 'Dengan melanjutkan, Anda menyetujui ',
    /**
     * 按钮文案
     */
    Continue: 'Lanjutkan',
    Confirm: 'Konfirmasi',
    ConfirmPayment: 'Konfirmasi pembayaran',
    queryOderState: 'Saya telah menyelesaikan pembayaran',
    orderRsult: 'Lanjutkan untuk membeli kripto',
    orderRsultTransList: 'Lanjutkan untuk membeli kripto',
    Proceed: 'Diproses',

    //风险账户文案
    accountTraded: 'Akun ini berisiko dan tidak dapat melakukan perdagangan sekarang.',
    /**
     * 组件
     */
    //kyc姓名为空提示
    cardinformation: 'Informasi kartu tidak tepat',
    //网络地址组件
    networkAddress_components_title: 'alamat',
    //协议组件
    agreement_components_text1: 'Saya memberi kuasa kepada ',
    agreement_components_text2: 'Alchemy Pay ',
    agreement_components_text3: 'untuk melakukan pendebitan atas jumlah yang disebutkan di atas dengan metode pembayaran yang saya pilih pada tanggal hari ini dan memahami bahwa pendebitan ini tidak dapat dibatalkan, ditarik kembali, atau dikembalikan dananya. ',
    //查询订单状态提示
    orderTips_title: 'Harap tunggu di halaman ini',
    orderTips_text1: 'Maaf, kami belum menerima pembayaran Anda. Jika Anda mengonfirmasi pembayaran, harap tunggu beberapa menit di halaman ini. Setelah kami menerima pembayaran Anda, kami akan mentransfer jumlah yang sesuai',
    orderTips_text2: 'kepada Anda.',
    orderTips_buttonText: 'Saya Memahami',
    //菜单
    menu: 'Menu',
    transactions: 'Transaksi',
    language: 'Bahasa Indonesia',
    terms: 'Ketentuan Layanan',
    privacy: 'Kebijakan Privasi',
    logOut: 'Keluar',

    /**
     * 路由
     */
    routerName_buy: 'Beli Kripto',
    routerName_sell: 'Jual Kripto',
    routerName_email: 'Masukkan Alamat Email',
    routerName_emailCode: 'Kode verifikasi',
    routerName_Transactions: 'Riwayat pesanan',
    routerName_Transactions_details: 'Riwayat pesanan',
    routerName_Refund: 'Minta pengembalian dana sebesar ',
    routerName_receivingMode: 'Terima ',
    routerName_paymentMethod: 'Pilih metode pembayaran',
    routerName_basisIdAuth: 'Autentikasi-Id-dasar',
    routerName_buyForm: 'Masukkan detail kartu',
    routerName_creditCardConfig: 'Konfirmasi Pembayaran',
    routerName_buyPayment: 'Pembayaran',
    routerName_buyOtherWayPay: 'Konfirmasi pembayaran Anda',
    routerName_paymentResult: 'Hasil pembayaran',
    routerName_sellForm: 'Pilih metode pembayaran',
    routerName_configSell: 'Konfirmasi',
    routerName_sellOrder: 'Pesanan',
    routerName_errorFormInfo: 'Kartu ini tidak tersedia sekarang',
    routerName_errorFormInfo2: 'Informasi Kartu Salah',
    routerName_kycOnfido: 'Bukti ID & Swafoto',
    routerName_kycSumsub: 'Bukti ID & Swafoto & POA',

    /**
     * 登陆
     */
    login: 'Gabung',
    login_required: 'Kesalahan Format.',
    loginOut: 'Keluar',
    loginOut_Dismiss: 'Tolak',

    loginTitle1: 'Checkout dengan Alchemy Pay',
    loginTitle2: 'Cara tercepat dan teraman untuk checkout ratusan aplikasi kripto.',

    codeTitle2: 'Tidak diterima? ',
    codeTitle3: 'Kode verifikasi baru telah dikirim ',
    codeSecond: 's',
    code_text: 'Saya telah membaca dan menyetujui pembayaran Alchemy ',
    code_name: 'Ketentuan Layanan',
    code_and: 'dan',
    code_name2: 'Kebijakan Privasi',
    login_Youlogged: 'Anda sudah login',

    /**
     * 首页
     */
    copyTips: 'berhasil menyalin',
    // 买币标题
    home_buyTitle: 'Beli Kripto',
    //卖币标题
    home_sellTitle: 'Jual Kripto',
    home_minAmountTips: 'Jumlah transaksi minimum adalah',
    home_maxAmountTips: 'Jumlah transaksi maksimum adalah',
    home_feeTimeDownTitle: 'Waktu yang tersisa',
    home_feeTimeDown: 'Pembaruan penawaran dalam',
    home_feeRampFeeTips: 'serendah',

    /**
     * 买币
     */
    home_youPay: 'Anda Membayar',
    home_youBuyGet: 'Anda mendapatkan',
    home_buyFee_timeDownTitle: 'Waktu yang tersisa',
    home_buyFee_timeDown: 'Pembaruan penawaran dalam',
    home_buyFee_title1: 'Anda Mendapatkan',
    home_buyFee_title2: 'untuk',
    home_buyFee_rampFee: 'Biaya pemrosesan',
    home_buyFee_networkFee: 'Biaya Jaringan',
    //卖币
    home_youSell: 'Anda Menjual',
    home_youSellGet: 'Anda Mendapatkan',
    home_sellFee_title1: 'Anda menjual',
    home_sellFee_title2: 'ke',
    home_sellFee_rampFee: 'Biaya pemrosesan',
    //搜索组件
    search_components_countryTitle: 'Pilih negara',
    search_components_cryptoTitle: 'Pilih kripto',
    search_components_networkTitle: 'Pilih jaringan',
    search_components_currencyTitle: 'Pilih mata uang fiat',

    //买币 - 选择接收方式
    buy_receivingMode_tips: 'Masukkan alamat dompet Anda.',
    buy_receivingMode_addressTitle: 'Anda ',
    buy_receivingMode_addressPlaceholder: 'Alamat Dompet…',
    buy_receivingMode_networkTitle: 'Alamat ACH Anda',
    buy_receivingMode_networkPlaceholder: 'Pilih Jaringan',
    buy_receivingMode_addressTips1: 'Bukan alamat',
    buy_receivingMode_addressTips2: 'yang valid.',
    //买币 - 选择支付方式
    buy_payment_savedTitle: 'Metode pembayaran tersimpan',
    buy_payment_addTitle: 'Tambahkan metode pembayaran baru',
    buy_payment_instant: 'Instan',
    buy_payment_ending: 'Berakhir',
    //买币 - 确认订单 - 国际卡
    buy_configPay_title1: 'Membayar dengan',
    buy_configPay_title2: 'CVV',
    buy_configPay_title3: 'Saya mengonfirmasikan bahwa pembayaran telah diselesaikan.',
    buy_configPay_title4: 'Konfirmasi',
    buy_configPay_title5: 'Batal',
    //买币 - 填写表单 - 国际卡
    buy_form_firstName: 'Nama depan',
    buy_form_lastName: 'Nama belakang',
    buy_form_cardNumber: 'Nomor kartu',
    buy_form_expirationDate: 'Tanggal kedaluwarsa',
    buy_form_CVV: 'CVV',
    buy_form_dataTips: 'Tanggal kedaluwarsa tidak valid',
    buy_form_cardNumTips: 'Harap masukkan nomor kartu yang valid.',
    buy_form_cvvTips: 'Masukkan CVV yang valid',

    //买币 - 确认订单 - 印尼支付
    buy_configPayIDR_va_title: 'BANK',
    buy_configPayIDR_va_codeTitle: 'Kode Pembayaran',
    buy_configPayIDR_timeDownTips: 'Harap selesaikan pembayaran dengan',
    buy_configPayIDR_codeTips: 'Pindai Kode QR untuk menyelesaikan pembayaran',
    buy_configPayIDR_ovo_phoneTips: 'Buka apl OVO untuk menyelesaikan pembayaran.',
    //订单结果页
    payResult_errorMessage: 'Faktur Kedaluwarsa!',
    payResult_timeErrorMessage: 'Pembayaran gagal, harap periksa info metode pembayaran atau coba ganti dengan metode yang lain.',
    // payResult_otherErrorMessage: 'Terjadi kesalahan pembayaran, coba lagi atau gunakan metode pembayaran yang lain',
    payResult_feeAmount: 'Jumlah',
    payResult_feeAddress: 'Alamat',
    payResult_feeHash: 'Hash',
    payResult_feeWallet: 'Dompet',
    payResult_feePassword: 'Dompet ACH',
    payResult_createdTime: 'Waktu pesanan',
    payResult_orderNo: 'No Pesanan',

    //菜单栏语言
    RouterMenu_Welcome: 'Selamat datang di Alchemy Pay!',
    RouterMenu_experience: 'Login untuk membuka agar mendapatkan pengalaman penuh',
    RouterMenu_Transactions: 'Transaksi',
    RouterMenu_history: 'Belum ada riwayat',
    RouterMenu_Language: 'Bahasa Indonesia',
    RouterMenu_Service: 'Ketentuan Layanan',
    RouterMenu_Policy: 'Kebijakan Privasi',
    RouterMenu_logout: 'Anda yakin ingin keluar?',
    RouterMenu_Dismiss: 'Tolak',

    sell_configOrder_title: 'Kartu Bank',

    //表单页
    sell_form_tips: 'kiat',
    sell_form_Name: 'Nama',
    sell_form_NameTips: 'Nama Tidak Valid!',
    sell_form_Address: 'Alamat',
    sell_form_AddressTips: 'Alamat Tidak Valid!',
    sell_form_AddressMultinomialTips: 'Alamat tidak boleh kosong',
    sell_form_City: 'Kota',
    sell_form_CityTips: 'Kota Tidak Valid!',
    sell_form_State: 'Negara Bagian',
    sell_form_StateTips: 'Negara Bagian Tidak Valid!',
    sell_form_Postcode: 'Kode Pos',
    sell_form_PostcodeTips: 'Kode Pos Tidak Valid!',
    sell_form_accountNumber: 'Nomor Akun',
    sell_form_accountNumberTips: 'Nomor Akun Tidak Valid!',
    sell_form_achCode: 'Kode ACH',
    sell_form_achCodeTips: 'Kode ACH Tidak Valid!',
    sell_form_contactNumber: 'Nomor Kontak',
    sell_form_contactNumberTips: 'Nomor Kontak Tidak Valid!',
    sell_form_swiftCode: 'Kode Swift',
    sell_form_swiftCodeTips: 'Kode Swift Tidak Valid!',
    sell_form_branchName: 'Nama Cabang',
    sell_form_branchNameTips: 'Nama Cabang Tidak Valid!',
    sell_form_branchNameMultinomialTips: 'Nama cabang tidak boleh kosong',
    sell_form_accountType: 'Jenis Akun',
    sell_form_accountTypeTips: 'Jenis Akun Tidak Valid!',
    sell_form_bankAccountType: 'Jenis Akun Bank',
    sell_form_bankAccountTypeTips: 'Jenis Akun Bank Tidak Valid!',
    sell_form_bankAccountTypeLi_Saving: 'Tabungan',
    sell_form_bankAccountTypeLi_Checking: 'Cek',
    sell_form_bankAccountTypeLi_TimeDeposit: 'Deposito Berjangka',
    sell_form_bankAccountTypeLi_Others: 'Lainnya',
    sell_form_bankCode: 'Kode Bank',
    sell_form_bankCodeTips: 'Kode Bank Tidak Valid!',
    sell_form_branchCode: 'Kode Cabang',
    sell_form_branchCodeTips: 'Kode Cabang Tidak Valid!',
    sell_form_locationId: 'Id Lokasi',
    sell_form_locationIdTips: 'Id Lokasi Tidak Valid!',
    sell_form_CPFNumber: 'Nomor CPF',
    sell_form_CPFNumberTips: 'Nomor CPF Tidak Valid!',
    sell_form_IDType: 'Jenis ID',
    sell_form_IDTypeTips: 'Jenis ID Tidak Valid!',
    sell_form_bankAccountTypeLi_CUIT: 'CUIT',
    sell_form_bankAccountTypeLi_CUIL: 'CUIL',
    sell_form_IDNumber: 'Nomor ID',
    sell_form_IDNumberTips: 'Nomor ID Tidak Valid!',
    sell_form_accountTypeLi_Maestra: 'Maestra',
    sell_form_IDTypeLi_DNI: 'DNI',
    sell_form_IDTypeLi_RUC: 'RUC',
    sell_form_IDTypeLi_CE: 'CE',
    sell_form_IDTypeLi_PASS: 'PASS',
    sell_form_RUTNumber: 'Nomor RUT',
    sell_form_RUTNumberTips: 'Nomor RUT Tidak Valid!',
    sell_form_BSBCode: 'Kode BSB',
    sell_form_BSBCodeTips: 'Kode BSB Tidak Valid!',
    sell_form_Email: 'Email',
    sell_form_EmailTips: 'Email Tidak Valid!',
    sell_form_SortCode: 'Kode Urut',
    sell_form_SortCodeTips: 'Kode Urut Tidak Valid!',
    sell_form_IFSC: 'IFSC',
    sell_form_IFSCTips: 'IFSC tidak valid!',
    sell_form_IDTypeLi_NIT: 'NIT',
    sell_form_IDTypeLi_CC: 'CC',
    sell_form_IDTypeLi_TI: 'TI',
    sell_form_IDTypeLi_RUT: 'RUT',
    sell_form_IDTypeLi_CI: 'CI',
    sell_form_TransitNumber: 'Nomor Transit',
    sell_form_TransitNumberTips: 'Nomor Transit Tidak Valid!',
    sell_form_bankSwiftTips: 'Kode swift dan id lokasi tidak boleh kosong secara bersamaan',
    sell_form_bankSwiftCodeTips: 'Kode bank dan kode swift tidak boleh kosong secara bersamaan',
    // sell_form_bankCodeLocationIdTips: 'Kode bank dan id lokasi tidak boleh kosong secara bersamaan',

    // 后增
    history_state_Complete: 'Selesai',
    history_state_Processing: 'Memproses',
    history_state_Transfer: 'Kripto terkirim',
    history_listTitle1: 'No Pesanan',
    history_listTitle2: 'Kripto',
    history_listTitle3: 'ID Hash',
    fee_listTitle_price: 'Harga',
    sell_order_title: 'status-konten',
    fee_tips: 'Berdasarkan metode pembayaran',
    search_components_Popular: 'Populer',
    search_components_All: 'Semua',
    search_components_placeHolder: 'Cari di sini… ',
    result_stateTo4_your: 'Anda',
    result_stateTo4: 'pesanan sedang diproses dan akan segera dikirimkan ke alamat yang Anda berikan. ',
    result_stateTo5: 'telah ditransfer ke alamat dompet Anda.',
    result_returnText_merchant: 'Kembali ke',
    result_returnText_merchant1: 'Kembali',
    buy_configPayIDR_ovo_title: 'Telepon OVO',
    login_getCode: 'Kirim ulang kode',
    login_VerifyCode: 'Harap masukkan kode verifikasi enam digit',
    login_Agreement: 'Harap centang Perjanjian Pengguna'
  },
  // 账号禁用页面
  accountDisabled: {
    title: 'Akun dinonaktifkan',
    content: 'Sayangnya, akun Anda telah dinonaktifkan karena ketidakpatuhan terhadap syarat dan ketentuan kami',
    buttonText: 'Pelajari selengkapnya'
  },
  // 巴西支付失败页
  pixPayError: {
    tips: 'Maaf, kami tidak dapat memperoleh Identitas Warga Brasil Anda sehingga PlX tidak tersedia untuk Anda. Harap pilih fiat atau metode pembayaran lain untuk membeli kripto.'
  },

  // 信息异常页面
  unauthorizedAccess: {
    tips: 'Akses tidak sah'
  },
  // kyc_onfido
  kycAlert: {
    waiting_msg: 'Bukti ID & Swafoto Anda dalam peninjauan:',
    success_msg: 'Verifikasi Identitas Berhasil',
    failure_msg: 'Kirim ulang Dokumen terkait'
  },
  kycStatus: {
    account: 'Akun:',
    login_time: 'Waktu login terakhir:',
    verify_succeeded: {
      tips: 'Verifikasi Identitas Berhasil',
      content: 'Selamat! Semua dokumen yang dikirimkan lulus proses verifikasi. Batas perdagangan harian Anda telah ditingkatkan menjadi jumlah yang setara dengan {0}',
      process: 'Proses'
    },
    verify_exception: {
      tips: 'Kirim ulang Dokumen terkait',
      update_document: 'Perbarui dokumen'
    },
    verify_failed: {
      tips: 'Verifikasi Identitas Ditolak'
    },
    verify_waiting: {
      received_documents: 'Kami telah menerima dokumen KYC Anda.',
      notify_you: 'Kami akan memberi tahu Anda setelah hasil verifikasi keluar melalui email. Prose ini biasanya akan membutuhkan waktu 5 hingga 10 menit. Dalam beberapa kasus langka, audit ulang manual akan dilakukan. Peninjauan manual akan diselesaikan dalam waktu 24 jam.',
      leave: 'Tinggalkan sekarang',
      under_review: 'Dalam Peninjauan...',
      estimated_time: 'Perkiraan waktu tunggu:',
      waiting_time: 'Anda telah menunggu selama:',
      reviewed_now: 'Dokumen yang dikirimkan Anda sedang ditinjau saat ini.'
    }
  },
  sellFormUserInfo: {
    bank_transfer: 'Transfer Bank',
    card_information: 'Informasi Kartu',
    personal_information: 'Informasi Pribadi',
    digit_code_3: 'Kode 3 digit',
    digit_number_3: 'Angka 3 digit',
    digit_number_4: 'Angka 4 digit',
    digit_number_5: 'Angka 5 digit',
    digit_code_6: 'Kode 6 digit',
    digit_number_6: 'Angka 6 digit',
    character_code_8_11: 'Kode 8-11 karakter',
    character_code_6_11: 'Kode 6-11 karakter',
    character_code_8: 'Kode 8 karakter',
    digit_number_9: 'Angka 9 digit',
    ach_number: 'Nomor perutean ACH',
    account_information: 'Informasi akun',
    account_type: 'Jenis Akun',
    account_holder: 'Pemilik akun',
    account_number: 'Nomor akun',
    address_account_holder: 'Alamat pemegang akun',
    bsb_code: 'Kode BSB',
    bank_account_number: 'Nomor akun bank',
    bank_account_type: 'Jenis akun bank',
    bank_code: 'Kode Bank',
    bank_code1: 'Kode bank (Kode kliring/Kode urut)',
    branch_code: 'Kode cabang',
    city: 'Kota',
    id_type: 'Jenis ID',
    full_name: 'Harap masukkan nama lengkap Anda',
    own_address: 'Harap masukkan alamat Anda sendiri',
    postcode: 'Kode Pos',
    sort_code: 'Kode urut',
    state: 'Negara Bagian',
    swift_code: 'Kode swift',
    transit_code: 'Kode transit',
    digit_number_six: 'Angka 6 digit misalnya 12-34-56',
    country: 'Negara',
    bank_name: 'nama Bank',
    enter_bank_name: 'Masukkan nama bank Anda',
    current: 'Saat ini',
    bank_address: 'Alamat bank',
    enter_bank_address: 'Masukkan alamat bank'
  },
  buyNavTab: {
    step: 'Langkah {0} dari 3'
  }
};
